export default "build/ec5e80b5208502ba.mp3"